import { Skeleton } from "@mui/material";
import Cookies from "js-cookie";

const EditQuestionListSkeleton = () => {
    const mode = Cookies.get("theme-mode");
    return (
        <div className="py-5">
            <div
                className={`rounded-2xl border transition-all duration-300 p-4 flex flex-row items-center justify-between gap-4 min-h-[96px] w-full shadow-sm mb-3 overflow-visible max-w-4xl mx-auto ${mode === 'light'
                    ? 'bg-white border-slate-200'
                    : 'bg-slate-900 border-slate-800'
                    }`}
            >
                {/* 1. Title Section Skeleton matching TextField bounds */}
                <div className="relative flex-1 w-full lg:max-w-[450px] flex flex-col gap-1.5">
                    <Skeleton
                        animation="wave"
                        variant="rounded"
                        width="100%"
                        height={56}
                        className={`rounded-2xl ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                    />
                </div>

                {/* 2. Topic Picker Area Skeleton */}
                <div className="w-full lg:w-[220px] flex flex-col gap-1.5">
                    <Skeleton
                        animation="wave"
                        variant="rounded"
                        width="100%"
                        height={56}
                        className={`rounded-2xl ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                    />
                </div>

                {/* 3. Sequence Toggle Card Skeleton */}
                <div className="flex flex-col gap-1.5 w-full lg:w-auto">
                    <div
                        className={`flex items-center gap-3 px-4 py-2 h-[56px] w-full lg:w-[150px] rounded-2xl border-2 transition-all ${mode === 'light' ? 'bg-slate-50 border-slate-100' : 'bg-slate-900 border-slate-800'
                            }`}
                    >
                        <Skeleton
                            animation="wave"
                            variant="circular"
                            width={34}
                            height={20}
                            className={mode === 'light' ? '' : 'bg-slate-700/60'}
                        />
                        <Skeleton
                            animation="wave"
                            variant="text"
                            width={60}
                            height={16}
                            className={mode === 'light' ? '' : 'bg-slate-700/60'}
                        />
                    </div>
                </div>

                {/* 4. Metadata Badge (Date Created) Skeleton */}
                <div className={`flex flex-col lg:items-end flex-1 w-full gap-1.5`}>
                    <div className="flex items-center lg:justify-end gap-2 h-[56px] w-full">
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={110}
                            height={28}
                            className={`rounded-full ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                        />
                    </div>
                </div>
            </div>
            {[...Array(9)].map((_, index) => (
                <div
                    key={index}
                    className={`font-sans rounded-2xl border transition-all duration-300 p-4 flex flex-row items-center justify-between gap-4 min-h-[96px] w-full shadow-sm mb-3 overflow-visible max-w-4xl mx-auto ${mode === 'light'
                        ? 'bg-white border-slate-200'
                        : 'bg-slate-900 border-slate-800'
                        }`}
                >
                    {/* Left Side: Question ID Block Indicator */}
                    <div className="flex-shrink-0 flex items-center justify-center z-50">
                        <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={40}
                            height={40}
                            className={`rounded-xl ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                        />
                    </div>

                    {/* Center Dynamic Content Area */}
                    <div className="flex-1 min-w-0 flex flex-col justify-center gap-2 z-50">

                        {/* Top Meta Details Row (Badges and Action Cluster) */}
                        <div className="flex flex-wrap items-center justify-between gap-2 w-full">
                            {/* Badges Stack */}
                            <div className="flex items-center gap-2 flex-wrap">
                                {/* Points Badge */}
                                <div className="rounded-md px-1.5 py-0.5 flex items-center gap-1">
                                    <Skeleton animation="wave" variant="circular" width={10} height={10} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                    <Skeleton animation="wave" variant="text" width={50} height={12} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                </div>
                                {/* Duration Badge */}
                                <div className="rounded-md px-1.5 py-0.5 flex items-center gap-1">
                                    <Skeleton animation="wave" variant="circular" width={10} height={10} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                    <Skeleton animation="wave" variant="text" width={55} height={12} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                </div>
                                {/* Difficulty Status Badge */}
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={45}
                                    height={16}
                                    className={`rounded-md ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                                />
                                {/* Bloom Taxonomy Badge */}
                                <div className="rounded-md px-1.5 py-0.5 flex items-center gap-1">
                                    <Skeleton animation="wave" variant="circular" width={10} height={10} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                    <Skeleton animation="wave" variant="text" width={65} height={12} className={mode === 'light' ? '' : 'bg-slate-700/60'} />
                                </div>
                            </div>

                            {/* Action Controls cluster (Copy & Delete button icons) */}
                            <div className="flex items-center gap-2 flex-shrink-0">
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={34}
                                    height={34}
                                    className={`rounded-xl ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                                />
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    width={34}
                                    height={34}
                                    className={`rounded-xl ${mode === 'light' ? '' : 'bg-slate-700/60'}`}
                                />
                            </div>
                        </div>

                        {/* Bottom Main Question Text String Representation */}
                        <div className="w-full">
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width="85%"
                                height={24}
                                className={mode === 'light' ? '' : 'bg-slate-700/60'}
                            />
                        </div>
                    </div>

                    {/* Right Side: Chevron Expanded Toggle Arrow Indicator */}
                    <div className="flex-shrink-0 flex items-center justify-center z-50">
                        <Skeleton
                            animation="wave"
                            variant="circular"
                            width={20}
                            height={20}
                            className={mode === 'light' ? '' : 'bg-slate-700/60'}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
};
export default EditQuestionListSkeleton;